module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDE1IDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8cGF0aCBkPSJNMTMuNzIwMiA3QzEzLjcyMDIgNyA3LjQwMzU0IDAuOTg4NDc5IDcuNzEyMDIgMS4wMDAwMUM4LjAyMDUgMS4wMTE1NSAxLjcyMDIxIDYuOTgzNjMgMS43MjAyMSA2Ljk4MzYzIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/up-arrow-icon.svg
// module id = RBPA
// module chunks = 11